export const tableColumnsScheme = [
    {
        text: '№',
        fraction: 0.04,
    },
    {
        text: 'Наименование',
        fraction: 0.24,
    },
    {
        text: 'Габариты, мм',
        fraction: 0.184,
    },
    {
        text: 'Вес, кг',
        fraction: 0.095,
    },
    {
        text: 'Цена за шт., ₽',
        fraction: 0.18,
    },
    {
        text: 'Кол-во, шт.',
        fraction: 0.13,
    },
    {
        text: 'Сумма, ₽ ',
        fraction: 0.131,
    },
];

export const tableColumnsSchemeSpecial = [
    {
        text: '№',
        fraction: 0.04,
    },
    {
        text: 'Наименование',
        fraction: 0.42,
    },
    {
        text: 'Габариты, мм',
        fraction: 0.315,
    },
    {
        text: 'Вес, кг',
        fraction: 0.095,
    },
    // {
    //     text: 'Цена за шт., ₽',
    //     fraction: 0.18,
    // },
    {
        text: 'Кол-во, шт.',
        fraction: 0.13,
    },
    // {
    //     text: 'Сумма, ₽ ',
    //     fraction: 0.131,
    // },
];

export const tablePadding=3;
